/**
 * Studio-mode banner — only shown when the SPA is built with
 * VITE_COSTPLUS_MODE=studio (offline LocalStorageClient mode for dev / sales
 * demos). In production we deploy with VITE_COSTPLUS_MODE=connected and the
 * banner is invisible — flows are persisted to the orchestrator and the user
 * is signed in.
 */

import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { getApiClient } from "../lib/apiClient";

export function StudioBanner() {
  const [dismissed, setDismissed] = useState(false);
  // Connected mode is the production deploy; the banner is dev-only noise
  // there. Render nothing.
  if (getApiClient().mode !== "studio") return null;
  if (dismissed) return null;
  return (
    <div className="bg-amber-100 dark:bg-amber-950/40 border-b border-amber-200 dark:border-amber-900 px-6 py-2 text-xs flex items-center gap-3">
      <AlertTriangle className="w-4 h-4 text-amber-700 dark:text-amber-400 shrink-0" />
      <p className="flex-1">
        <span className="font-medium text-amber-900 dark:text-amber-200">
          Studio mode.
        </span>{" "}
        Flows are saved to this browser only. Export your flows to back them up.
        Paid checkout sessions are not available.
      </p>
      <button
        onClick={() => setDismissed(true)}
        className="text-amber-700 dark:text-amber-400 hover:text-amber-900 dark:hover:text-amber-200"
        aria-label="Dismiss banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
